import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { Clock, CheckCircle2, XCircle, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// A small floating banner (below the header) that lets a signed-in user track the
// status of their creator application. Creators/admins never see it.
export function ApplicationStatusBanner() {
  const { isAuthenticated, isCreator, isAdmin, accessToken } = useAuth();
  const [app, setApp] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || isCreator || isAdmin || !accessToken) {
      setApp(null);
      return;
    }
    let active = true;
    axios
      .get(`${API}/creator-applications/mine`, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((res) => { if (active) setApp(res.data.application || null); })
      .catch(() => { /* not signed in / no application — silent */ });
    return () => { active = false; };
  }, [isAuthenticated, isCreator, isAdmin, accessToken]);

  if (!app) return null;

  const cfg = {
    pending:  { icon: Clock,        cls: 'bg-yellow-500/10 border-yellow-500/30 text-yellow-500', text: 'Tvoje žádost o tvůrce se posuzuje. Ozveme se ti e-mailem.', link: null },
    approved: { icon: CheckCircle2, cls: 'bg-green-500/10 border-green-500/30 text-green-400',   text: 'Tvoje žádost byla schválena! Vítej mezi tvůrci.',          link: '/creator' },
    rejected: { icon: XCircle,      cls: 'bg-red-500/10 border-red-500/30 text-red-400',          text: 'Tvoje žádost o tvůrce bohužel nebyla schválena.',          link: null },
  }[app.status];
  if (!cfg) return null;

  // Dismiss is remembered per (application, status) so a status change re-shows it.
  const key = `appbanner_${app.id}_${app.status}`;
  if (dismissed || (typeof localStorage !== 'undefined' && localStorage.getItem(key))) return null;

  const Icon = cfg.icon;
  const dismiss = () => {
    try { localStorage.setItem(key, '1'); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <div className="fixed top-16 left-0 right-0 z-40 flex justify-center px-4 pointer-events-none">
      <div className={`pointer-events-auto mt-2 flex items-center gap-3 rounded-lg border px-4 py-2.5 text-sm shadow-lg backdrop-blur ${cfg.cls}`}>
        <Icon className="w-4 h-4 shrink-0" />
        <span>{cfg.text}</span>
        {cfg.link && <Link to={cfg.link} className="underline font-medium shrink-0">Přejít</Link>}
        <button onClick={dismiss} className="ml-1 opacity-70 hover:opacity-100 shrink-0" aria-label="Zavřít">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
